var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddBulkUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 135,
    viewBox: "0 0 135 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H134.449V134.449H0V0Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2231 123.245H22.4067V11.2036H112.04V67.2242",
    stroke: "#399E79",
    strokeWidth: 7.31632,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4365 123.245V86.8313",
    stroke: "#399E79",
    strokeWidth: 7.31632,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8325 96.6349L91.0341 92.4334L99.4371 84.0303L107.84 92.4334L112.042 96.6349",
    stroke: "#399E79",
    strokeWidth: 7.31632,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8152 44.8159H89.6316",
    stroke: "#399E79",
    strokeWidth: 7.31632,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8152 67.2241H67.2234",
    stroke: "#399E79",
    strokeWidth: 7.31632,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBulkUploadIcon);
export default __webpack_public_path__ + "static/media/addBulkUploadIcon.a87296c3a064701195c38362e9c26052.svg";
export { ForwardRef as ReactComponent };